// One-click transcript download for the live room and the archived meeting (Claire, Oct 28 scrum).
import { clock } from "./liveRoom";

interface Line { speaker: string; text: string; startSec?: number }


export const transcriptText = (title: string, lines: Line[]) =>
  `${title}\n\n${lines.map((l) => `${l.speaker}${l.startSec != null ? ` (${clock(l.startSec)})` : ""}: ${l.text}`).join("\n")}\n`;

export const transcriptFileName = (title: string, date?: string | null) => {
  const safe = String(title || "Meeting").replace(/[\/\\:*?"<>|]+/g, " - ").replace(/\s+/g, " ").replace(/( - )+/g, " - ").trim();
  return `${String(date || new Date().toISOString()).slice(0, 10)} - ${safe} - transcript.txt`;
};

export const downloadText = (fileName: string, text: string) => {
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// copy to the clipboard; older views refuse the clipboard API, so fall back to a hidden text box
export const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const box = document.createElement("textarea");
    box.value = text;
    box.style.position = "fixed";
    box.style.opacity = "0";
    document.body.appendChild(box);
    box.select();
    const ok = document.execCommand && document.execCommand("copy");
    box.remove();
    return Boolean(ok);
  }
};
